import { render, staticRenderFns } from "./DirectionList.vue?vue&type=template&id=29cbbd1d"
import script from "./DirectionList.vue?vue&type=script&lang=js"
export * from "./DirectionList.vue?vue&type=script&lang=js"
import style0 from "./DirectionList.vue?vue&type=style&index=0&id=29cbbd1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports